﻿import React from "react";
import './Key.css';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Icon, Position } from "@blueprintjs/core";
import { ShowHide } from "components/layout";
import { Tooltip } from "components/tooltip";

export function KeyBlock(
    {
        size = 10,
        rounded = false,
        icon = null,
        selectable = false,
        selected = false,
        loading = false,
        onClick = () => { },
        iconColour = "#FFFFFF",
        hideBorder = false,
        toolTipText = "",
        tooltipPosition = Position.TOP,
        className,
        colours
    }
) {

    const fourColours = 4;
    const threeColours = 3;
    const twoColours = 2;

    const firstColour = 0;
    const secondColour = 1;
    const thirdColour = 2;
    const fourthColour = 3;

    function calculateColours(coloursValue) {
        if (!Array.isArray(coloursValue)) {
            return coloursValue;
        }

        switch (coloursValue.length) {
            case fourColours:
                return `${coloursValue[firstColour]} ${coloursValue[secondColour]} ${coloursValue[thirdColour]} ${coloursValue[fourthColour]}`;
            case threeColours:
                return `${coloursValue[firstColour]} ${coloursValue[firstColour]} ${coloursValue[secondColour]} ${coloursValue[thirdColour]}`;
            case twoColours:
                return `${coloursValue[firstColour]} ${coloursValue[firstColour]} ${coloursValue[secondColour]} ${coloursValue[secondColour]}`;
            default:
                return coloursValue[firstColour];
        }
    }

    function handleClick() {
        onClick();
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    }

    return (
        <div className={classNames("key-item-container", className)} style={{ width: size * 2, height: size * 2 }} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex={-1}>
            <Tooltip position={tooltipPosition} content={toolTipText} disabled={loading || !toolTipText || toolTipText.length < 1}>
                <div className={classNames("key-item", { "loading": loading, "rounded": rounded, "empty": colours?.length === 0, "selectable": selectable, "selected": selected, "key-item-border": !hideBorder })} style={{ "borderWidth": size, "borderColor": calculateColours(colours) }}></div>
            </Tooltip>
            <ShowHide evaluator={icon !== null}
                show={(
                    <div className="key-icon">
                        <Icon icon={icon} size={(size * 2) - 6} color={iconColour} />
                    </div>
                )}
            />
        </div>
    );
}

KeyBlock.propTypes = {
    colours: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    size: PropTypes.number,
    rounded: PropTypes.bool,
    icon: PropTypes.string,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    iconColour: PropTypes.string,
    hideBorder: PropTypes.bool,
    toolTipText: PropTypes.string,
    tooltipPosition: PropTypes.string
};